import { render } from "./Calling.vue?vue&type=template&id=16fba3b1"
import script from "./Calling.vue?vue&type=script&lang=js"
export * from "./Calling.vue?vue&type=script&lang=js"

import "./Calling.vue?vue&type=style&index=0&id=16fba3b1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__